import ReactCountryFlag from "react-country-flag";

import {
  CURRENCY_CONFIG,
  DEFAULT_CURRENCY_CODE,
} from "../../constants/currencies.constants";

import "./index.scss";

export const CurrencyLabelWithFlag = ({
  currencyCode = DEFAULT_CURRENCY_CODE,
  flagPlacement = "before",
}) => {
  return (
    <span className="currency-flag-label">
      {flagPlacement === "before" && (
        <ReactCountryFlag
          countryCode={CURRENCY_CONFIG[currencyCode]?.countryFlagCode}
          svg
        />
      )}
      <span>{CURRENCY_CONFIG[currencyCode]?.displayLabel}</span>
      {flagPlacement === "after" && (
        <ReactCountryFlag
          countryCode={CURRENCY_CONFIG[currencyCode]?.countryFlagCode}
          svg
          style={{ width: "12px", height: "12px" }}
        />
      )}
    </span>
  );
};

export const getCurrencyOptionsWithFlag = (flagPlacement = "before") => {
  return Object.keys(CURRENCY_CONFIG).map((currencyCode) => ({
    value: currencyCode,
    conversionRatio: CURRENCY_CONFIG[currencyCode]?.conversionRatio ?? 1,
    searchText: CURRENCY_CONFIG[currencyCode]?.displayLabel,
    label: (
      <CurrencyLabelWithFlag
        currencyCode={currencyCode}
        flagPlacement={flagPlacement}
      />
    ),
  }));
};
